module.exports = __webpack_public_path__ + "public/images/header/tg-logo.5aeaafa6da74a30705af445b54b131ee.svg";